import { Asset } from "@models/interfaces";
import { CRYPTO_TYPE, ERC20_TOKEN_FAMILY } from "@helpers/constants";

export class Cryptocoin extends Asset {
	protected precision_for_tx = 8;
	private family: string = "";

	protected readonly tradable_actions: string[] = ["buy", "sell", "swap", "transfer", "savings", "send", "deposit"];
	protected static readonly currencyType: string = CRYPTO_TYPE;

	public getCurrencyType(): string {
		return Cryptocoin.currencyType;
	}

	public isErc20Family(): boolean {
		return this.family === ERC20_TOKEN_FAMILY;
	}

	public getPrecision(): number {
		return this.precision_for_coins;
	}

	public getPrecisionForTx(): number {
		return this.precision_for_tx;
	}

	public supportsTag(): boolean {
		return this.support_destination_tag;
	}

	public getWalletMinDeposit(): number {
		return this.getAssetSettings()?.getWalletMinDeposit() ?? 0;
	}

	public getSmallDeposit(): number {
		return this.getAssetSettings()?.getSmallDeposit() ?? 0;
	}

	public getSmallDepositFee(): number {
		return this.getAssetSettings()?.getSmallDepositFee() ?? 0;
	}

	public isStellar(): boolean {
		return this.getSymbol(true) === "xlm";
	}

	public isIota(): boolean {
		return this.getSymbol(true) === "miota";
	}

	public isHodlTradable(type: string): boolean {
		return this.hasInfo() && type === "buy" && !(this.isWithdrawActive() && this.isDepositActive());
	}
}
